var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 1.86364C0.5 1.11052 1.11052 0.5 1.86364 0.5H14.1364C14.8895 0.5 15.5 1.11052 15.5 1.86364V14.1364C15.5 14.8895 14.8895 15.5 14.1364 15.5H1.86364C1.11052 15.5 0.5 14.8895 0.5 14.1364V1.86364ZM3 3C3 2.53976 3.3731 2.16667 3.83333 2.16667H12.1667C12.6269 2.16667 13 2.53976 13 3V13C13 13.4602 12.6269 13.8333 12.1667 13.8333H3.83333C3.3731 13.8333 3 13.4602 3 13V12.1667H3.83333V12.5833C3.83333 12.8135 4.01988 13 4.25 13H11.75C11.9801 13 12.1667 12.8135 12.1667 12.5833V3.41667C12.1667 3.18655 11.9801 3 11.75 3H4.25C4.01988 3 3.83333 3.18655 3.83333 3.41667V3.83333H3V3ZM5.5 8.83333V11.3333L8.83333 8L5.5 4.66667V7.16667H1.33333V8.83333H5.5Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/Import.ce0c7de6d96814ea789814b11d9da3ae.svg";
export { ForwardRef as ReactComponent };